import { useQuery } from '@apollo/react-hooks';
import { useBrand } from '@bnnvara/brand';
import { Menu, MenuItem } from '@bnnvara/menu';
import get from 'lodash/get';
import React from 'react';

import { SubNavigationQuery } from '../../api/queries/menu.gql';
import useSharedRef from '../../hooks/useSharedRef';
import Link, { useLink } from '../Link';
import StyledSubNavigation from './styled';

const SubNavigation = () => {
  const { slug: brandSlug } = useBrand();
  const { isCurrent } = useLink();

  const { loading, data } = useQuery(SubNavigationQuery, {
    variables: {
      slug: brandSlug,
    },
  });

  const { createRef } = useSharedRef();
  const ref = createRef('subNavigation');

  return (
    <StyledSubNavigation ref={ref}>
      <Menu>
        {!loading &&
          get(data, 'brand.menuItems', []).map(({ id, slug, body }, index) => {
            const isActive = isCurrent(slug);
            const gaLabel = `${index}-${body.replace(/\s/g, '-')}`;

            return (
              <MenuItem key={id} isActive={isActive}>
                <Link
                  href={slug}
                  category="brandnavigatie"
                  action="click"
                  label={gaLabel}
                >
                  {body}
                </Link>
              </MenuItem>
            );
          })}
      </Menu>
    </StyledSubNavigation>
  );
};

export default SubNavigation;
